const tr = {
  'Invalid credentials': 'Geçersiz kimlik bilgileri!',
  'Project detail': 'Proje Detayı',
  Documents: 'Dokümanlar',
  'Foreign key constraint failed': 'İşlem tamamlanamadı: İlişkili bir kayıt bulunamadı.',
  Unauthorized: 'Bu işlem için yetkiniz bulunmuyor.',
  'All users': 'Tüm Kullanıcılar',
}

export default tr;